export default __webpack_public_path__ + "static/media/80s_bg_right@3x.90fe0c8a.jpg";